import { wrapRootElement as ssrWrapRootElement } from './gatsby-ssr';

export const wrapRootElement = ssrWrapRootElement;

export default {};
